<template>
  <el-dialog
    title="选择业务员"
    :visible="visible"
    width="50%"
    @open="handleOpen"
    @close="handleClose"
    destroy-on-close
    append-to-body
  >
    <div style="height: 480px">
      <el-form :inline="true" :model="formInline">
        <el-form-item label="姓名">
          <el-input
            size="small"
            v-model="formInline.name"
            placeholder="输入姓名"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            size="small"
            type="primary"
            icon="el-icon-search"
            @click="handleSearch"
            >搜索</el-button
          >
          <el-button
            size="small"
            type="info"
            icon="el-icon-delete"
            @click="handleReset"
            >清空</el-button
          >
        </el-form-item>
      </el-form>
      <el-table
        size="small"
        :data="userData"
        highlight-current-row
        v-loading="loading"
        border
        row-key="id"
        height="380"
        element-loading-text="拼命加载中"
        style="width: 100%"
        @row-click="handleClick"
      >
        <el-table-column align="center" type="index" width="60">
        </el-table-column>
        <el-table-column
          sortable
          prop="realName"
          label="名称"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          sortable
          prop="dept"
          label="部门"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <div>{{ scope.row.dept.name }}</div>
          </template>
        </el-table-column>
        <el-table-column
          sortable
          prop="gender"
          label="性别"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <div>{{ scope.row.gender === "1" ? "男" : "女" }}</div>
          </template>
        </el-table-column>
        <el-table-column
          sortable
          prop="phone"
          label="联系电话"
          show-overflow-tooltip
        >
        </el-table-column>
      </el-table>
    </div>
    <div slot="footer">
      <el-button type="primary" size="small" @click="handleConfirm"
        >确定</el-button
      >
      <el-button size="small" @click="handleClose">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { listSalesman } from "@/api/system/user";

export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      formInline: {
        name: "",
      },
      userData: [],
      pager: {
        currentPage: 1,
        pageSize: 10,
        total: 1,
      },
      selectRow: null,
      loading: false,
    };
  },
  methods: {
    getData() {
      this.loading = true;
      listSalesman(this.formInline.name)
        .then((list) => {
          this.userData = list;
        })
        .catch(this.$message.error)
        .finally(() => {
          this.loading = false;
        });
    },
    handleSearch() {
      this.getData();
    },
    handleReset() {
      this.formInline = {
        name: "",
      };
      this.getData();
    },
    handleClick(row) {
      this.selectRow = row;
    },
    handleConfirm() {
      if (this.selectRow) {
        this.$emit("confirm", this.selectRow);
        this.handleClose();
      } else {
        this.$message({
          type: "warning",
          message: "请选择节点",
        });
      }
    },
    handleOpen() {
      this.getData();
    },
    handleClose() {
      this.$emit("update:visible", false);
    },
  },
};
</script>

 
 

 


// WEBPACK FOOTER //
// src/views/components/salesman.vue